import { Box, Center } from "@chakra-ui/react"
import { motion } from "framer-motion"
import PropTypes from "prop-types"
import { useFlashcard } from "./FlashcardProvider"

const cardVarients = {
  faceUp: {
    rotateY: 0,
    zIndex: 1,
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 220,
      damping: 40
    }
  },
  faceDown: {
    rotateY: -180,
    zIndex: 0,
    opacity: 0,
    // 0.9 seems to cause a bit of jank
    // scale: 0.9,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 220,
      damping: 40
    }
  }
}

export const CardFace = ({ children, ...props }) => {
  return (
    <Center
      as={motion.div}
      pos="absolute"
      w="full"
      h="full"
      bg="background"
      color="text"
      p={6}
      left={0}
      top={0}
      right={0}
      bottom={0}
      shadow={"0 0 10px 1px rgba(150,150,150,0.3)"}
      overflow={"hidden"}
      textAlign={"center"}
      __css={{
        perspective: 1000,
        backfaceVisibility: "hidden"
      }}
      {...props}
    >
      {children}
    </Center>
  )
}

const CardFlipper = ({ renderFront, renderBack, size = "100%", ...props }) => {
  const { isFlipped, setIsFlipped } = useFlashcard()

  const handleFlip = () => {
    setIsFlipped(!isFlipped)
  }

  return (
    <Box
      as={motion.div}
      onClick={handleFlip}
      h={size}
      pos="relative"
      initial={{ scale: 0.9 }}
      animate={{ scale: 1 }}
      cursor="pointer"
      {...props}
    >
      <>
        <CardFace
          variants={cardVarients}
          initial={isFlipped ? "faceDown" : "faceUp"}
          animate={isFlipped ? "faceDown" : "faceUp"}
        >
          {renderFront({ onFlip: handleFlip })}
        </CardFace>
        <CardFace
          variants={cardVarients}
          initial={isFlipped ? "faceUp" : "faceDown"}
          animate={isFlipped ? "faceUp" : "faceDown"}
        >
          {renderBack({ onFlip: handleFlip })}
        </CardFace>
      </>
    </Box>
  )
}

CardFlipper.propTypes = {
  renderFront: PropTypes.func.isRequired,
  renderBack: PropTypes.func.isRequired,
  size: PropTypes.number
}

export default CardFlipper
